
import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography, Grid, Button, Stack, Dialog, DialogTitle, DialogContent, DialogActions, debounce } from "@mui/material";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import AddIcon from '@mui/icons-material/Add';
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDateTimePicker from "../commoncomponents/CustomDateTimePicker";
import { useDispatch, useSelector } from "react-redux";
import workOrderSummaryRepositry from "../../api/repositories/workOrderSummaryRepositries";
import dayjs from "dayjs";
import { format } from "date-fns";
import CustomDialog from "../commoncomponents/CustomDialog";
import { v4 as uuidv4 } from 'uuid';
import { addRepairTrackerForVendor, clearRepairTrackerForVendor, updateRepairTrackerForVendor } from "../../redux/actions/vendor/webFormActions";
import PageLoader from "../commoncomponents/PageLoader";
import { useLocation } from "react-router-dom";
const AddRowDialogue = ({ open, onClose,  editMode, rows, setRows,locationState,responseData}) => {

  const dispatch = useDispatch();
  const initialState = {
    employeename: '',
    vendor:'',
    technician: '',
    flag: {},
    pic: {},
    activity: {},
    startDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    endDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    repairDuration: "0 Mins",
    remarks: "",
  };

  const [itemData, setItemData] = useState(initialState || {});
  const assetCategoryType = locationState?.serviceType || "";
  const categoryType = locationState?.categoryType;
  const serviceType = assetCategoryType === "FEMS" ? "fem" : "bem";
  const categoryFieldName = categoryType === "Scheduled" ? "scheduled" : "unscheduled";
  const [vendorIdToLabelMap, setVendorIdToLabelMap] = useState(new Map());
  const [vendorName, setVendorName] = useState("");

  const [option, setOption] = useState({
    employeename: [],
    flag: [],
    pic: [],
    activity: [],
  });

  const [error, setError] = useState({
    startDateandTime: false,
    endDateandTime: false,
    employeename:false
  });

  const [errorMessage, setErrorMessage] = useState({
    startDateandTime: "",
    endDateandTime: "",
    employeename:""
  });
  
  const handleGridDataChange = (value, name) => {
    const values = name === "repairDuration" || name === "preparationHours" || name === "verificationHours"
      ? value?.slice(0, 2) + value?.slice(2) : value;

    setItemData((previous) => {
      const updatedData = {
        ...previous,
        [name]: values || "",
      };
      
      if (name === "employeename" ) {
        updatedData.employeename = { ...value, label: value?.employeename ? value?.employeename : '' };
      };

      if (name === "startDateandTime" || name === "endDateandTime") {
        const start = new Date(updatedData.startDateandTime);
        const end = new Date(updatedData.endDateandTime);
        if (start && end && end >= start) {
          const durationInMs = end - start;
          const totalMinutes = Math.floor(durationInMs / (1000 * 60)); // Convert duration to total minutes
          updatedData.repairDuration = `${totalMinutes} Mins`;
        } else {
          updatedData.repairDuration = "0 Mins";
        }
      };
      
      return updatedData;
    });

    setError((prev) => {
      const updatedError = {
          ...prev,
          [name]: false
      };
      return updatedError;
    });

    setErrorMessage((prev) => ({
        ...prev,
        [name]: ''
    }));

    let workOrderTime = responseData[0]?.[`${serviceType}${categoryFieldName}workorderheaders`][0]?.workorderdate || ''
        const workOrderDateAndTime = new Date(workOrderTime);
        const selectedDate = new Date(value);
        const currentDate = new Date();
        const endDate = new Date(itemData?.endDateandTime);
    
        if (name === 'startDateandTime' && value) {
    
          if (selectedDate < workOrderDateAndTime || selectedDate > currentDate) {
            setError((prevErrors) => ({
              ...prevErrors,
              startDateandTime: true,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              startDateandTime: "Start date and time should be between Work Order date and current date/time.",
            }));
          } else {
            setError((prevErrors) => ({
              ...prevErrors,
              startDateandTime: false,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              startDateandTime: "",
            }));
          }
    
          if (endDate && selectedDate) {
            if (selectedDate >= endDate) {
              setError((prevErrors) => ({
                ...prevErrors,
                endDateandTime: true,
              }));
              setErrorMessage((prevErrorMessages) => ({
                ...prevErrorMessages,
                endDateandTime: "End date and time should be greater than the Start date and time.",
              }));
            } else {
              setError((prevErrors) => ({
                ...prevErrors,
                endDateandTime: false,
              }));
              setErrorMessage((prevErrorMessages) => ({
                ...prevErrorMessages,
                endDateandTime: "",
              }));
            }
          };
        };
    
        if (name === 'endDateandTime' && value) {
          const selectedEndDateTime = new Date(value);
          const startDateTime = new Date(itemData?.startDateandTime);
          if (
            // selectedEndDateTime.toDateString() !== startDateTime.toDateString() || // If the dates are not the same
            selectedEndDateTime < startDateTime
            // selectedEndDateTime > currentDate
          ) {
            setError((prevErrors) => ({
              ...prevErrors,
              endDateandTime: true,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              endDateandTime: "End date and time should be greater than the Start date and time.",
            }));
          } else {
            setError((prevErrors) => ({
              ...prevErrors,
              endDateandTime: false,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              endDateandTime: "",
            }));
          };
        };
  };


  // Fetch vendor details and create a mapping of vendorId to vendorName
  const getVendorDetails = async () => {
    try {
      const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
      const vendorMap = new Map(vendorDetails.map((v) => [v.id, v.vendorname]));
      setVendorIdToLabelMap(vendorMap);
    } catch (error) {
      console.error("Error fetching vendor details:", error);
    }
  };

  // Map response data to get the correct vendor ID
  const getVendorId = () => {
    if (serviceType === "fem" && categoryType === "Scheduled") {
      return responseData?.femscheduledworkorderheaders?.[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || responseData?.vendorId;
    } else if (serviceType === "bem" && categoryType === "Scheduled") {
      return responseData?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || responseData?.vendorId;
    } else if (serviceType === "fem" && categoryType === "Unscheduled") {
      return responseData?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid || responseData?.vendorId;
    } else if (serviceType === "bem" && categoryType === "Unscheduled") {
      return responseData?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid || responseData?.vendorId;
    }
    return null; // Default to null if no match
  };

  // Set the vendor name based on the vendor ID and the map
  useEffect(() => {
    getVendorDetails(); // Fetch vendor details when component mounts
  }, []);

  useEffect(() => {
    if(responseData && vendorIdToLabelMap){
      const vendorId = getVendorId();
      const vendorName = vendorIdToLabelMap.get(vendorId) || "";
      setVendorName(vendorName);
    };
  }, [vendorIdToLabelMap, serviceType, categoryType, responseData]);


  const fetchOption = async () => {

    const lovOptions = await workOrderSummaryRepositry.lovOptions();
    setOption((previous) => ({
      ...previous,
      flag: lovOptions?.femuschworepairflags?.map((item, index) => ({
        key: `option${index}`,
        label: item?.repairflag,
        id: item?.id
      }))
    }));

    setOption((previous) => ({
      ...previous,
      pic: lovOptions?.femuschworepairpics?.map((item, index) => ({
        key: `option${index}`,
        label: item?.repairpic,
        id: item?.id
      }))
    }));

    setOption((previous) => ({
      ...previous,
      activity: lovOptions?.femuschworepairactivities?.map((item, index) => ({
        key: `option${index}`,
        label: item?.repairactivity,
        id: item?.id
      }))
    }));
  };

  useEffect(() => {
    fetchOption();
  }, []);


  const handleCancel = () => {
    setItemData(initialState);
    onClose();
    setErrorMessage({});
    setError({});
  };

  const handleValidationForRequiredFields = () => {
    let isValid = true;
    
    // Check for required fields
    if (!itemData.startDateandTime) {
      setError((prev) => ({ ...prev, startDateandTime: true }));
      setErrorMessage((prev) => ({ ...prev, startDateandTime: "Start Date and Time is required" }));
      isValid = false;
    }
    if (!itemData.endDateandTime) {
      setError((prev) => ({ ...prev, endDateandTime: true }));
      setErrorMessage((prev) => ({ ...prev, endDateandTime: "End Date and Time is required" }));
      isValid = false;
    }
    
    return isValid;
  };


  const handleSave = async (e) => {

    e.preventDefault();
    const isValid = handleValidationForRequiredFields();
    if (!isValid) return;
    
    if (editMode?.dummy_id || editMode?.id) {
      if (editMode?.id) {
        // Update existing row
        const updatedRows = rows.map((row) =>
          row.id === editMode?.id ? itemData : row
        );
        setRows(updatedRows);
      } else if (editMode?.dummy_id) {
        // Update existing row
        const updatedRows = rows.map((row) =>
          row?.dummy_id === editMode?.dummy_id ? itemData : row
        );
        setRows(updatedRows);
      };
      dispatch(updateRepairTrackerForVendor("UPDATE_REPAIR_TRACKER_DETAILS_FOR_VENDOR",{ ...itemData } ));
    } else {
      // Add new row
      const newItem = {
        ...itemData,
        dummy_id: uuidv4(),
        vendorId:vendorName || ""
      };
      dispatch(addRepairTrackerForVendor("ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR", { ...newItem }))
      setItemData(initialState);
    }
    onClose();
  };
  
  useEffect(() => {
    if (editMode?.dummy_id || editMode?.id) {
      if (editMode?.dummy_id) {
        setItemData({
          dummy_id: editMode?.dummy_id || "",
          activity: {
            key: editMode.activity?.key || "",
            label: `${editMode.activity?.label || ""}` || "",
            id: editMode.activity?.id || "",
          },
          flag: {
            key: editMode.flag?.key || "",
            label: `${editMode.flag?.label || ""}` || "",
            id: editMode.flag?.id || "",
          },
          pic: {
            key: editMode.pic?.key || "",
            label: `${editMode.pic?.label || ""}` || "",
            id: editMode.pic?.id || "",
          },
          preparationHours: editMode?.preparationHours || "",
          remarks: editMode?.remarks || "",
          repairDuration: editMode?.repairDuration || "",
          startDateandTime: editMode?.startDateandTime || "",
          endDateandTime: editMode?.endDateandTime || "",
          verificationHours: editMode?.verificationHours || "",
          id:editMode?.id || "",
          technician: editMode?.technician || "",
          
        });
      } else if (editMode?.id) {
        setItemData({
          dummy_id: editMode?.dummy_id || "",
          activity: {
            key: editMode.activity?.key || "",
            label: `${editMode.activity?.label}` || "",
            id: editMode.activity?.id || "",
          },
          flag: {
            key: editMode.flag?.key || "",
            label: `${editMode.flag?.label}` || "",
            id: editMode.flag?.id || "",
          },
          pic: {
            key: editMode.pic?.key || "",
            label: `${editMode.pic?.label}` || "",
            id: editMode.pic?.id || "",
          },
          preparationHours: editMode?.preparationHours || "",
          technician: editMode?.technician || "",
          remarks: editMode?.remarks || "",
          repairDuration: editMode?.repairDuration || "",
          startDateandTime: editMode?.startDateandTime || "",
          endDateandTime: editMode?.endDateandTime || "",
          verificationHours: editMode?.verificationHours || "",
          id:editMode?.id || "",
          timeStamp: editMode?.timeStamp || "",
        });
      }

    } else {
      setItemData(initialState);
    }
  }, [editMode]);

  const isAddDisabled =
  // !(itemData?.employeename?.label || itemData?.technician) ||
  !itemData?.technician ||
  !itemData.startDateandTime ||
  !itemData.endDateandTime ||
  error.startDateandTime ||
  error.endDateandTime ||
  itemData.startDateandTime === "" ||
  itemData.endDateandTime === "";


  return (
    <Dialog
      open={open}
    >
      <DialogTitle>
        <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>{editMode ? "Edit Repair Tracker" : "Add Repair Tracker"}</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
        <Grid item xs={6} md={6}>
            <CustomTextField
              label={"Vendor"}
              id={"vendor"}
              name={"vendor"}
              value={vendorName || responseData?.vendorname || ""}
              onChange={handleGridDataChange}
              disabled={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomTextField
              label={"Vendor Technician"}
              id={"technician"}
              name={"technician"}
              value={itemData?.technician}
              onChange={handleGridDataChange}
              isMandatoryField={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomSelectInput
              label="Flag"
              id="flag"
              name="flag"
              options={option?.flag || []}
              value={itemData?.flag || {}}
              onChange={handleGridDataChange}
              modal={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomSelectInput
              label={"Unit"}
              name="pic"
              value={itemData?.pic || ""}
              onChange={handleGridDataChange}
              options={option?.pic || []}
              modal={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomSelectInput
              label="Activity"
              id="activity"
              name="activity"
              onChange={handleGridDataChange}
              value={itemData?.activity}
              options={option?.activity || []}
              modal={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomDateTimePicker
              label="Start Date and Time"
              onDateChange={(e) => handleGridDataChange(e, "startDateandTime")}
              value={itemData?.startDateandTime || ""}
              modal={true}
              disableFutureDate={false}
              error={error?.startDateandTime}
              helperText={errorMessage?.startDateandTime}
              isMandatoryField={true}
              displayDefaultValue={false}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomDateTimePicker
              label="End Date and Time"
              onDateChange={(e) => handleGridDataChange(e, "endDateandTime")}
              value={itemData?.endDateandTime || ""}
              shouldValidateFutureTime={true}
              modal={true}
              disableFutureDate={false}
              error={error?.endDateandTime}
              helperText={errorMessage?.endDateandTime}
              isMandatoryField={true}
              displayDefaultValue={false}

            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomTextField
              label={"Repair Duration"}
              id={"repairDuration"}
              name={"repairDuration"}
              value={itemData?.repairDuration}
              onChange={handleGridDataChange}
              disabled
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomTextField
              label={"Remarks"}
              id={"remarks"}
              name={"remarks"}
              value={itemData?.remarks}
              onChange={handleGridDataChange}
              maxlength={255}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleSave} disabled={isAddDisabled}>
        {editMode ? "UPDATE" : "ADD"}
        </Button>
        <Button variant="outlined" onClick={handleCancel}>
          CANCEL
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const RepairTrackerEditForm = ({ locationState, onRepairTrackerRowsChange, responseData }) => {
  const location = useLocation();
  const [gridApi, setGridApi] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false); // For controlling Add Row Dialog
  const [deleteId, setDeleteId] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const webFormdata = useSelector((state) => state?.vendorWebForm);
  const [editData, setEditData] = useState(null);
  const repairTrackerRows = webFormdata?.repairTracker || [];
  const [rows, setRows] = useState([]); // Grid rows state
  const [isLoading, setIsLoading] = useState(false);
  const assetCategoryType = locationState?.serviceType || "";
  const serviceType = assetCategoryType === "FEMS" ? "fem" : "bem";
  const categoryType = locationState?.categoryType;
  const dispatch = useDispatch();
  const assesmentsId = webFormdata?.otherRespondedDeatils?.assessmentId || "";
  const getstatusId = assetCategoryType === "FEMS" ? location?.state?.femworkorderstatusId : location?.state?.bemworkorderstatusId;
  const checkstatus = [4,5,8,9].includes(getstatusId) ? true : false;


  const formatDate = (dateString) => {
    if (!dateString) {
      return '';
    }
    return format(new Date(dateString), 'dd/MM/yyyy HH:mm:ss');
  };

  const columns_Field = [
    // { field: 'vendorId', headerName: 'Vendor', flex: 1 },
    { field: 'vendorName', headerName: 'Vendor', flex: 1, valueGetter: (params) => params?.data ? params?.data?.vendorName || webFormdata?.vendorName || "" : "" },
    { field: 'technician', headerName: 'Vendor Technician', flex: 1 },
    { field: 'flag', headerName: 'Flag', flex: 1, valueGetter: (params) => params?.data?.flag ? params?.data.flag?.label : '' },
    { field: 'pic', headerName: 'Unit', flex: 1, valueGetter: (params) => params?.data?.pic ? params?.data.pic?.label : '' },
    { field: 'activity', headerName: 'Activity', flex: 1, valueGetter: (params) => params?.data?.activity ? params?.data.activity?.label : '' },
    { field: 'startDateandTime', headerName: 'Start Date/Time', flex: 1, valueGetter: (params) => formatDate(params?.data?.startDateandTime) },
    { field: 'endDateandTime', headerName: 'End Date/Time', flex: 1, valueGetter: (params) => formatDate(params?.data?.endDateandTime) },
    { field: 'repairDuration', headerName: 'Repair Duration', flex: 1 },
    { field: 'remarks', headerName: 'Remarks', flex: 1 }
  ];

  const getRows = async (assesmentsId) => {
  const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();

  try {
    if (assesmentsId) {
      const listRows = await workOrderSummaryRepositry.getRepairDetails(
        serviceType,
        assesmentsId,
        categoryType
      );

      const vendorIdToLabelMap = new Map(
        vendorDetails.map((v) => [v.id, v.vendorname])
      );

      const mappedRowsArray = listRows
        ?.filter((row) => !row?.employeeid) // only vendor rows
        ?.map((row) => {
          return {
            id: row?.id,
            technician: row?.vendortechnician || "",
            flag: { id: row?.worepairflagId || "", label: row?.worepairflag || "" },
            pic: { id: row?.worepairpicId || "", label: row?.worepairpic || "" },
            activity: {
              id: row?.worepairactivityId || "",
              label: row?.worepairactivity || "",
            },
            startDateandTime: row?.repairstartdate || "",
            endDateandTime: row?.repairenddate || "",
            repairDuration: row?.repairduration || "",
            remarks: row?.remarks || "",
            timeStamp: row?.timestamp || "",
            vendorId: row?.vendorid || "",
            vendorName:
              row?.vendorname || vendorIdToLabelMap.get(row?.vendorid) || "",
            vendorCode: row?.vendorCode || "",
          };
        });


      // Set the state with the entire array of mapped rows
      setRows((prevRows) => [...prevRows, ...mappedRowsArray]);
      dispatch(clearRepairTrackerForVendor("CLEAR_REPAIR_TRACKER_FOR_VENDOR", []));

      // Dispatch each mapped row to the Redux store
      mappedRowsArray?.forEach((mappedRow) => {
        dispatch(
          addRepairTrackerForVendor(
            "ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
            mappedRow
          )
        );
      });
    }
  } catch (error) {
    console.error("Error in getRows:", error);
  }
};

  useEffect(() => {
    setIsLoading(true);
    getRows(assesmentsId);
    setIsLoading(false);
  }, [assesmentsId]);

  const handleOpenDialog = useCallback(() => {
    setDialogOpen(true); // Open Add Row Dialog
  }, []);
  

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditData(null);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setDialogOpen(true);
  };

  const handleConfirm = useCallback((newRow) => {
    // Add the new row to the grid and update state
    setRows((prevRows) => [...prevRows, newRow]); // Append new row to current rows

    // Dispatch to Redux to add the new row
    dispatch(addRepairTrackerForVendor("ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR", newRow));
    handleCloseDialog(); // Close dialog after adding row
  }, [dispatch, handleCloseDialog]);

  const handleDelete = (row) => {
    setDeleteDialog(true);
    setDeleteId(row);
  };

  const handleCloseCancelDialog = () => {
    setDeleteDialog(false);
  };

  const handleConfirmDelete = async () => {
    try {
      let updatedRows = [];
      if (deleteId?.id) {
        await workOrderSummaryRepositry.deleteRepairTracker(serviceType, categoryType, deleteId?.id);
        updatedRows = rows.filter((row) => row.id !== deleteId.id);
        setRows(updatedRows);
        dispatch({ type: 'DELETE_REPAIR_TRACKER_DETAILS_FOR_VENDOR', payload: { id: deleteId.id } });
      } else if (deleteId?.dummy_id) {
        updatedRows = rows.filter((row) => row.dummy_id !== deleteId.dummy_id);
        setRows(updatedRows);
        dispatch({ type: 'DELETE_REPAIR_TRACKER_DETAILS_FOR_VENDOR', payload: { dummy_id: deleteId.dummy_id } });
      }
      setDeleteDialog(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
    <PageLoader open={isLoading} />
      <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between">
          <Typography variant='title2' >Repair Tracker</Typography>
          <Box sx={{ flexGrow: 1 }} />
          {!((locationState?.isViewMode) || (checkstatus))  && <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleOpenDialog}>
            Add Row
          </Button>}
        </Stack>
        <Box mb={2} />
        <CustomAgGrid
          rows={repairTrackerRows}
          columns={columns_Field}
          setGridApi={setGridApi}
          handleDelete={!((locationState?.isViewMode) || (checkstatus)) ? handleDelete : null}
          handleEdit={!((locationState?.isViewMode) || (checkstatus)) ? (row)=>handleEdit(row) : null}
        />
      </Box>

      <AddRowDialogue
        open={dialogOpen}
        onClose={handleCloseDialog}
        onConfirm={handleConfirm}
        editMode={editData}
        rows={rows}
        setRows={setRows}
        locationState={locationState}
        responseData={responseData}
      />

      <CustomDialog
        open={deleteDialog}
        onClose={handleCloseCancelDialog}
        onConfirm={handleConfirmDelete}
        content="Are you sure you want to Delete?"
        cancelBtn="No"
        confirmBtn="Yes"
      />
    </>
  );
};

export default React.memo(RepairTrackerEditForm);
